import { updateFullMatch } from "@/api/matches";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { invalidateMatchLists } from "./invalidateMatchLists";

export const useUpdateFullMatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateFullMatch,
    // Without this the matches list kept its pre-save rows (score, status,
    // lock) until the page was reloaded.
    onSuccess: () => invalidateMatchLists(queryClient),
  });
};
